import { render, staticRenderFns } from "./CVItem.vue?vue&type=template&id=72985b73&scoped=true&"
import script from "./CVItem.vue?vue&type=script&lang=js&"
export * from "./CVItem.vue?vue&type=script&lang=js&"
import style0 from "./CVItem.vue?vue&type=style&index=0&id=72985b73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72985b73",
  null
  
)

export default component.exports